/* unplugin-vue-components disabled */import script from "./tiktokDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./tiktokDetail.vue?vue&type=script&setup=true&lang=ts"

import "./tiktokDetail.vue?vue&type=style&index=0&id=c75ae57c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c75ae57c"]])

export default __exports__